exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.file {\n  margin:1ex;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/upload-box/upload-box.component.css
// module id = ../../../../../src/app/upload-box/upload-box.component.css
// module chunks = main